<template>
  <Wrapper class="max-w-2xl">
    <div class="mb-3 text-left">
      <h2 class="text-xl"><b>Información de la nueva entidad</b></h2>
      <p class="text-gray-500">
        Ingrese la información del usuario y el tipo de rol administrativo
      </p>
    </div>
    <form @submit.prevent="createCompany" class="mx-auto max-w-2xl">
      <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div class="col-span-2 grid grid-cols-1 lg:grid-cols-2 gap-4">
          <BaseInput
            type="text"
            label="Nombre"
            placeholder="Ej: Empresa S.A"
            v-model="form.name"
            :required="true"
          />
          <BaseInput
            type="text"
            label="Usuario/Correo"
            v-model="form.email"
            placeholder="Ej: ejemplo@ejemplo.com"
            :required="true"
          />
          <BaseInput
            id="primaryColor"
            type="text"
            label="Color primario (HEX)"
            v-model="form.primary_color"
            placeholder="#FFFFFF"
            autocomplete="off"
          />
          <BaseInput
            id="secondaryColor"
            type="text"
            label="Color Secundario (HEX)"
            v-model="form.secondary_color"
            placeholder="#FFFFFF"
            autocomplete="off"
          />
          <BaseSelect
            ref="channel"
            id="channel"
            label="Sector compañía"
            :selectOptions="formOptions.optionsSectors"
            v-model="form.sector"
            :required="true"
          />
          <BaseRadio
            ref="generatedCode"
            name="generatedCode"
            label="¿Generar automáticamente el código de la queja?"
            :radioOptions="formOptions.optionsYN"
            v-model="form.generated_code"
          />
          <div class="col-span-2 text-left">
            <div>
              <p class="mb-2 text-gray-500 text-sm font-bold">Logo entidad</p>
              <ul class="mb-3 text-xs text-gray-500">
                <li class="mb-1">Requisitos recomendados:</li>
                <li>
                  Formato PNG - Dimensiones 1280x365 - Logo en color blanco
                </li>
              </ul>
            </div>

            <div v-if="logo" class="flex flex-col gap-3">
              <div
                style="padding-top: 29.51%"
                class="w-full relative rounded-xl bg-gray-500 overflow-hidden"
              >
                <div v-if="logoUrl" class="absolute top-0 w-full h-full">
                  <img
                    id="companyLogo"
                    :src="logoUrl"
                    class="w-full h-full"
                    alt=""
                  />
                </div>
              </div>
              <span
                v-if="logo"
                class="inline-block p-2 rounded-lg border border-gray-300"
              >
                {{ logo.name }}
              </span>
              <Button :danger="true" @click.native="deleteLogoFile"
                ><a-icon type="delete"></a-icon> Eliminar
              </Button>
            </div>
            <div v-else>
              <label for="logo-input">
                <span
                  class="block text-center px-3 py-2 bg-secondary rounded-lg text-white font-bold cursor-pointer hover:bg-gray-400"
                  >Cargar archivo</span
                >
                <input
                  type="file"
                  ref="file"
                  id="logo-input"
                  accept=".png"
                  class="hidden"
                  @change="setLogoFile"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="col-span-2 text-left">
          <h2 class="mt-5 text-xl">
            <b>Información conexión con SFC</b>
          </h2>
          <p class="text-gray-500">
            Edite la información requerida para la conexión con la
            Superintendencia financiera
          </p>
        </div>
        <div class="col-span-2 grid grid-cols-1 lg:grid-cols-2 gap-4">
          <BasePassword
            label="Contraseña"
            v-model="form.password_sfc"
            placeholder="**********"
            autocomplete="off"
          />
          <BasePassword
            label="Key SFC"
            v-model="form.secret_key"
            placeholder="**********"
            autocomplete="off"
          />
          <BaseInput
            type="text"
            label="Código SFC"
            v-model="form.sfc_code"
            placeholder="Ej: 2"
            autocomplete="off"
          />
          <BaseInput
            type="text"
            label="Tipo SFC"
            v-model="form.sfc_company_type"
            placeholder="Ej: 45"
            autocomplete="off"
          />
        </div>
      </div>
      <div v-if="feedback">
        <p class="mt-8 text-xs text-center text-red-500">{{ feedback }}</p>
      </div>
      <div
        class="w-full mt-8 mr-auto flex flex-col lg:flex-row-reverse lg:justify-end gap-4"
      >
        <Button
          type="submit"
          styles="secondary"
          :block="true"
          :loading="loading"
          :disable="loading"
        >
          Crear
        </Button>
        <Button
          type="button"
          :danger="true"
          :invert="true"
          :block="true"
          :disable="loading"
          @click.native="$router.go(-1)"
        >
          Cancelar
        </Button>
      </div>
    </form>
  </Wrapper>
</template>

<script>
import { mapState } from 'vuex'
import Button from '../../UI/Button'
export default {
  components: { Button },
  data() {
    return {
      loading: false,
      feedback: null,
      form: {
        name: '',
        email: '',
        primary_color: '',
        secondary_color: '',
        password_sfc: '',
        secret_key: '',
        sfc_code: '',
        sfc_company_type: '',
        sector: '',
        generated_code: 1,
      },
      logo: null,
      logoUrl: '',
    }
  },
  watch: {
    logo(value) {
      if (!value) return
      const reader = new FileReader()
      reader.onload = (e) => {
        this.logoUrl = e.target.result
      }
      reader.readAsDataURL(value)
    },
  },
  methods: {
    async createCompany() {
      if (this.invalidForm()) return

      let formData = new FormData()
      Object.entries(this.form).forEach((entry) => {
        formData.append(entry[0], entry[1])
      })
      formData.append('file', this.logo)

      this.loading = true
      let response = await this.$api.companies.createCompany(formData)
      this.loading = false

      if (response.status !== 201) {
        this.$showNotification('error', response.data)
        return
      }

      this.$showNotification('success', 'Entidad creada correctamente')

      this.$router.go(-1)
    },
    setLogoFile() {
      this.logo = this.$refs.file.files[0]
    },
    deleteLogoFile() {
      this.logo = null
      this.logoUrl = null
    },
    invalidForm() {
      this.feedback = null

      if (this.$validator.isEmpty(this.form.name)) {
        this.feedback = 'Introduzca el nombre completo de la entidad'
        return true
      }
      if (this.$validator.isEmpty(this.form.email)) {
        this.feedback = 'Introduzca un usuario/correo'
        return true
      }
      if (
        this.form.primary_color &&
        !this.$validator.isHexColor(this.form.primary_color)
      ) {
        this.feedback =
          'El color primario debe contener un color hexadecimal válido'
        return true
      }
      if (
        this.form.secondary_color &&
        !this.$validator.isHexColor(this.form.secondary_color)
      ) {
        this.feedback =
          'El color secundario debe contener un color hexadecimal válido'
        return true
      }
      if (this.$validator.isEmpty(this.form.sector)) {
        this.feedback = 'Agregue el sector de la compañia'
        return true
      }
      if (this.$validator.isEmpty(this.form.password_sfc)) {
        this.feedback = 'Introduzca una contraseña'
        return true
      }
      if (this.$validator.isEmpty(this.form.secret_key)) {
        this.feedback = 'Introduzca la llave para conectarse a la SFC'
        return true
      }
      if (this.$validator.isEmpty(this.form.sfc_code)) {
        this.feedback = 'Introduzca el código de la entidad ante la SFC'
        return true
      }
      if (!this.$validator.isNumeric(this.form.sfc_code)) {
        this.feedback = 'Introduzca un código de entidad válido'
        return true
      }
      if (this.$validator.isEmpty(this.form.sfc_company_type)) {
        this.feedback = 'Introduzca el tipo de entidad ante la SFC'
        return true
      }
      if (!this.$validator.isNumeric(this.form.sfc_company_type)) {
        this.feedback = 'Introduzca un tipo de entidad válido'
        return true
      }

      return false
    },
  },
  computed: {
    ...mapState({ formOptions: 'form' }),
  },
}
</script>

<style></style>
